'use client';

import { HomeProductsSection } from '@/components/organisms/product-section';
import React from 'react';


const ProductSectionTastic = ({ data }: any) => {

  return (
    <>
    <HomeProductsSection data={data} />
    </>
  );
};

export default ProductSectionTastic;
